export default "mutation existsSyllabusByMajor($majorId: String,$name: String) {\n  existsSyllabusByMajor(majorId: $majorId,name: $name) \n}";